import { useRef, useCallback } from "react";

type RateLimiterOptions = {
  rate: number; // max messages
  per: number; // rolling window in ms
  onRateLimited?: (timeUntilReset: number) => void;
};

export function useRateLimiter(
  fn: (message: any) => void,
  { rate, per, onRateLimited }: RateLimiterOptions,
) {
  const timestampsRef = useRef<number[]>([]);

  const send = useCallback(
    (message: any) => {
      const now = Date.now();

      // Clean up old timestamps outside the window
      timestampsRef.current = timestampsRef.current.filter(
        (ts) => now - ts < per,
      );

      if (timestampsRef.current.length < rate) {
        timestampsRef.current.push(now);
        fn(message);
      } else {
        const oldest = timestampsRef.current[0];
        const timeUntilReset = per - (now - oldest);
        onRateLimited?.(timeUntilReset);
      }
    },
    [fn, rate, per, onRateLimited],
  );

  return send;
}
